import React from 'react'

import { GenericBoxResult } from '@dataplace.ai/ui-components/organisms'
import { ISnvPotentialModelTileData } from './@types/ISnvPotentialModel'

export const SnvPotentialModelResult: React.FC<{ data: ISnvPotentialModelTileData }> = ({ data }) => {
  const resultKey = data?.value?.potentialModel?.toLowerCase() || ''

  return (
    <GenericBoxResult
      hasData={!!data?.value}
      i18nKeys={{
        header: 'placeme.tile.snv_potential_model.header',
        paragraph: 'placeme.tile.snv_potential_model.paragraph',
        activeLabel: 'placeme.tile.snv_potential_model.result',
      }}
      loading={data?.loading}
      resultKey={resultKey}
    />
  )
}
